<template>

</template>

<script>
export default {
    name: "NewOrderListItem"
}
</script>

<style scoped>

</style>
